//SEE MSAL DOCS: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics#configuration-options
import * as Msal from "msal"; //AZURE B2C
import { progressData, result } from "./actions";
//TABLE OF CONTENTS
export const types = {
  GET_AUTH_SUCCESS: "GET_AUTH_SUCCESS", //on successful GET fetch call
  REDIRECTING_TO_LOGIN: "REDIRECTING_TO_LOGIN",
};

export const getAuthSuccess = (token, batchId) => {
  return { type: types.GET_AUTH_SUCCESS, token, batchId };
};

export const redirectingToLogin = boolean => {
  return { type: types.REDIRECTING_TO_LOGIN, boolean };
};

const tokenFromUrl = () => {
  //FIXME: workaround for issue https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/498
  try {
    return window.location.href.split("&id_token=")[1].length > 0;
  } catch (err) {
    return null; //token could not be found in url
  }
};

const loginHintFromUrl = () => {
  try {
    return window.location.href.split("&u=")[1]; //gets username from END of url &u=john.doe@gmail.com
  } catch (err) {
    return null; //username could not be found in url
  }
};

//returns access token to be used for fetch auth
export const getToken = () => async (dispatch, getState) => {
  const { expiresOn, token } = getState().auth;
  //get new token 1 min early
  const expiresOnWithBuffer = new Date(expiresOn.valueOf() - 60000);
  //check if expired
  if (new Date() > expiresOnWithBuffer) {
    await dispatch(getAuth()); //wait for new token
    return getState().auth.token; // return new token
  }
  return token;
};

//gets token and if init = true progresses data
export const getAuth = (init = false) => {
  return dispatch => {
    const loginRequest = {
      scopes: b2cScopes,
    };
    return userAgentApplication
      .acquireTokenSilent(loginRequest)
      .then(token => {
        //AcquireTokenSilent Success
        //get batch id from URL
        let batchId;
        try {
          batchId = new URLSearchParams(window.location.search).get("id");
        } catch (e) {
          batchId = null;
        }
        //if valid batch id init
        if (batchId) {
          dispatch(getAuthSuccess(token, batchId)); //dispatch user and token
          if (init) {
            dispatch(progressData());
          }
        } else {
          dispatch(
            result({
              status: "error",
              title:
                "Invalid URL. Return to the link provided and click it again",
            })
          );
        }
      })
      .catch(err => {
        //acquireTokenSilent fail, login
        const idToken = tokenFromUrl(); //get token from url, workaround for issue #498 in msal.js
        if (!idToken) {
          dispatch(redirectingToLogin(true)); //show redirecting

          const loginHint = loginHintFromUrl(); //get email
          userAgentApplication.loginRedirect(
            loginRequest,
            loginHint && `login_hint=${loginHint}`
          ); //redirect to login with login hint
        }
      });
  };
};

//AZURE B2C CONFIG
const b2cUrl = process.env.REACT_APP_B2C_URL;
const b2cScopes = [`${b2cUrl}users.write`, `${b2cUrl}users.read`];

export const userAgentApplication = new Msal.UserAgentApplication({
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    redirectUri: process.env.REACT_APP_UI_HOST,
    authority: process.env.REACT_APP_AUTHORITY,
    validateAuthority: false,
    b2cScopes,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
});

userAgentApplication.handleRedirectCallback((error, response) => {
  // if error is not null, something went wrong
  // if not, response is a successful login response
});

export const logout = () => {
  userAgentApplication.logout();
};
